"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inactiveTicketStatuses = exports.completedTicketStatuses = exports.isZendeskTicketStatus = exports.ZendeskTicketStatus = void 0;
var ZendeskTicketStatus;
(function (ZendeskTicketStatus) {
    ZendeskTicketStatus["new"] = "new";
    ZendeskTicketStatus["open"] = "open";
    ZendeskTicketStatus["pending"] = "pending";
    ZendeskTicketStatus["solved"] = "solved";
    ZendeskTicketStatus["closed"] = "closed";
    ZendeskTicketStatus["deleted"] = "deleted";
})(ZendeskTicketStatus || (exports.ZendeskTicketStatus = ZendeskTicketStatus = {}));
const isZendeskTicketStatus = (value) => {
    return Object.values(ZendeskTicketStatus).includes(value);
};
exports.isZendeskTicketStatus = isZendeskTicketStatus;
exports.completedTicketStatuses = [ZendeskTicketStatus.solved, ZendeskTicketStatus.closed];
exports.inactiveTicketStatuses = [...exports.completedTicketStatuses, ZendeskTicketStatus.deleted];
